import { Navigate, Route, Routes } from "react-router-dom"
import React from "react"

const CarryInManagerPlacementsPage = React.lazy(
    () => import("./PlacementsPage")
)
const DelegatedListingsPage = React.lazy(() => import("./DelegatedListings"))

export const CarryInRoutes = () => {
    return (
        <Routes>
            <Route
                path={`listings/:id`}
                element={<CarryInManagerPlacementsPage />}
            />
            <Route
                path={`delegatedListings`}
                element={<DelegatedListingsPage />}
            />
            <Route path="*" element={<Navigate to={`delegatedListings`} />} />
        </Routes>
    )
}
